import { AmenityGroup } from "@/src/app/Amenities/model";
import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { useEffect, useState } from "react";
import { fetch } from "@/src/lib/fetch";
import { Checkbox } from "@/src/components/ui/checkbox";
import { useOffersStore } from "../../../../stores/offersStore";

export function Amenitites() {
  const [amenityGroups, setAmenityGroups] = useState<AmenityGroup[]>([]);
  const { setAmenityGroups: setStoreGroups } = useOffersStore();

  const fetchAmenityGroups = () =>
    fetch<{ data: AmenityGroup[] }>("/api/amenities/groups").then((r) => {
      setAmenityGroups(r.data);
      setStoreGroups(r.data);
    });

  useEffect(() => {
    fetchAmenityGroups();
  }, []);

  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-3">Amenities</h3>
      <div className="flex flex-col gap-y-6 w-full">
        <div className="flex gap-x-4">
          <FormItem className="w-full grid-cols-2">
            {amenityGroups.map((g) => (
              <FormField
                key={g.id}
                name="amenities"
                render={({ field }) => {
                  return (
                    <FormItem key={g.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(g.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, g.id])
                              : field.onChange(field.value?.filter((value: any) => value !== g.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{g.name}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        </div>
      </div>
    </div>
  );
}
